import { t } from '@lingui/macro';
import { colorSystem } from '@luminovo/design-system';
import { BannerCard } from './BannerCard';
import { DownloadQuotationButton } from './DownloadQuotationButton';

export const BannerCardPaymentFailed = ({ rfqId }: { rfqId: string }): JSX.Element => {
    return (
        <BannerCard
            background={colorSystem.neutral[5]}
            title={t`The payment has failed.`}
            description={'Please contact your EMS to resolve this issue.'}
            callToAction={
                <DownloadQuotationButton
                    rfqId={rfqId}
                    color={colorSystem.neutral.white}
                    background="rgba(255, 255, 255, .3)"
                    hideIfNoQuotation
                />
            }
        />
    );
};
